// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
import { Vector3, IVector3 } from "./System.Numerics.Vector3.gen";
import { TargetHistory, ITargetHistory } from "./TargetHistory.gen";
import { DeviceTargetStatus } from "./Shared.DeviceTargetStatus.gen";
import { TargetType } from "./Shared.TargetType.gen";
import { FHWAClass } from "./Shared.FHWAClass.gen";
import { Lane } from "./Shared.Lane.gen";
import { TurnType } from "./Shared.TurnType.gen";
import { TargetStatus } from "./Shared.TargetStatus.gen";

export interface ITarget {
	startPosition: IVector3 | undefined;

	endPosition: IVector3 | undefined;

	deviceStatus: DeviceTargetStatus;

	currentPositionX: number;

	currentPositionY: number;

	currentVelocityX: number;

	currentVelocityY: number;

	history: ITargetHistory[] | undefined;

	id: string | undefined;

	externalId: string | undefined;

	deviceId: string | undefined;

	type: TargetType;

	fhwaClass: FHWAClass | undefined;

	lanes: Lane | undefined | number ;

	turn: TurnType | undefined;

	lastUpdate: string | undefined;

	statusStarted: string | undefined;

	status: TargetStatus;

	maxPointCount: number;

	hasPhoto: boolean;

	maximumVelocity: number | undefined;

	maximumWidth: number | undefined;

	maximumHeight: number | undefined;

	averageHeight: number | undefined;

	minimumHeight: number | undefined;

	averageVelocity: number | undefined;

	minimumVelocity: number | undefined;

	netFacilityCountChange: number;

	radarTrackId: number | undefined;

	cameraTrackId: number | undefined;

	$type?: string | undefined;
}
export class Target {
	constructor(data?: ITarget) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
		if (data.startPosition) { this.startPosition = new Vector3(data.startPosition); }
		if (data.endPosition) { this.endPosition = new Vector3(data.endPosition); }
		this.history = data.history ? data.history.map((h: any) => new TargetHistory(h)) : [];
		if (data.lastUpdate) { this.lastUpdate = new Date(data.lastUpdate); }
		if (data.statusStarted) { this.statusStarted = new Date(data.statusStarted); }
	}

	startPosition: Vector3 | undefined;

	endPosition: Vector3 | undefined;

	deviceStatus: DeviceTargetStatus = 0;

	currentPositionX: number = 0;

	currentPositionY: number = 0;

	currentVelocityX: number = 0;

	currentVelocityY: number = 0;

	history: TargetHistory[] | undefined = [];

	id: string | undefined;

	externalId: string | undefined;

	deviceId: string | undefined;

	type: TargetType = 0;

	fhwaClass: FHWAClass | undefined;

	lanes: Lane | undefined | number ;

	turn: TurnType | undefined;

	lastUpdate: Date | undefined = new Date();

	statusStarted: Date | undefined = new Date();

	status: TargetStatus = 0;

	maxPointCount: number = 0;

	hasPhoto: boolean = false;

	maximumVelocity: number | undefined;

	maximumWidth: number | undefined;

	maximumHeight: number | undefined;

	averageHeight: number | undefined;

	minimumHeight: number | undefined;

	averageVelocity: number | undefined;

	minimumVelocity: number | undefined;

	netFacilityCountChange: number = 0;

	radarTrackId: number | undefined;

	cameraTrackId: number | undefined;

	static $type: string = "CoreApi.Models.Target, ";
	$type?: string | undefined = Target.$type;
}

